import { useTranslation } from 'next-i18next';
import styled from 'styled-components';
import { getImagePath } from '../../../helpers/common';
import ImageWrapper from '../../../new-components/ImageWrapper';
import { Amenity } from '../../../new-lib/types/entity';

interface ChildProps {
  amenities: Amenity[];
}

const Amenities = ({ amenities }: ChildProps): JSX.Element => {
  const { t } = useTranslation('entity');

  return (
    <AmenitiesContainer data-test="amenities-section">
      <h3 className="headline-3 entity-title">{t('amenities')}</h3>
      <div className="amenities-wrapper">
        {amenities.map((item: any) => (
          <div className="amenity" key={item.name} itemProp="amenityFeature">
            <div className="icon">
              <ImageWrapper
                src={getImagePath(item?.imageUrl || item?.image_path)}
                alt={item.name}
                objectFit="cover"
                fill
                sizes="25vw"
              />
            </div>
            <span className="text-3">{item.name}</span>
          </div>
        ))}
      </div>
    </AmenitiesContainer>
  );
};

const AmenitiesContainer = styled.div`
  .amenities-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .amenity {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 16px;
      min-width: 180px;
      padding: 16px;
      padding-top: 0;

      .icon {
        width: 25px;
        height: 25px;
        position: relative;
      }
      span {
        font-size: 14px;
        text-transform: capitalize;
        font-family: materialRegular;
        line-height: 1;
      }
    }
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.tablet.max}) {
    .amenities-wrapper {
      gap: 16px 0;
      background-color: #f8f8f8;
      padding: 16px;
      border-radius: ${props => props.theme.borderRadius};
      .amenity {
        min-width: unset;
        width: 50%;
        padding: 0;
        gap: 8px;
        align-items: center;
      }
    }
  }
`;
export default Amenities;
